// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { reelsPlaysConfig } from '../reelsPlays';

export const reelsPlaysMVConfig: KpiType<typeof MediaViewerKpiLoader, typeof MediaViewerKPI> = {
    ...reelsPlaysConfig,
    name: 'kpi.facebook.plays',
    id: 'plays',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
